<template>
  <header
    class="pt-nav md:pt-nav-desktop relative min-h-[22rem] auto-rows-min grid-cols-2 bg-amber-100 px-4 pb-16 sm:px-20 md:min-h-[75vh] lg:grid lg:grid-cols-2"
  >
    <!-- TITLE -->
    <h1
      class="hyphens-auto lg:hyphens-none order-1 col-span-2 mt-12 max-w-[20ch] text-2xl font-medium sm:mt-24 md:text-7xl"
    >
      {{ page.title }}
    </h1>
    <!-- CATEGORIES -->
    <div
      class="order-2 col-start-1 mt-6 mb-10 flex flex-wrap gap-2 pr-10 md:mt-10"
    >
      <!-- link to mount page -->
      <div
        v-for="category in page.categories"
        :key="category.title"
        class="h-min w-fit"
      >
        <NuxtLink
          :to="{
            path: parentPageUrl,
            query: { filters: category.title },
          }"
          :aria-label="`Link zu allen Artikeln der Kategorie ${category.title}`"
          class="rounded-full px-4 py-[0.438rem] text-2xs !leading-tight text-gray-800 ring-1 ring-gray-800/70 transition-colors focus-visible:outline focus-visible:outline-offset-4 focus-visible:outline-blue-500 sm:py-2 md:px-[1.125rem] md:py-[0.5625rem]"
        >
          {{ category.title }}
        </NuxtLink>
      </div>
    </div>

    <!-- IMAGE -->
    <div class="order-3 col-span-1 col-start-2 pt-2 lg:pr-[20%]">
      <AppImage
        v-if="page.image"
        :src="page.image"
        :aspect-ratio="1.5"
        class="w-full rounded-md object-cover"
      />
    </div>
  </header>
</template>

<script setup>
defineProps({
  page: {
    type: Object,
    default: () => ({}),
  },
})
const route = useRoute()

// COMPUTED
const parentPageUrl = computed(() => {
  let parentUrl = route.params.uri.slice(0, -1)

  if (parentUrl.length === 0) {
    return `/${route.params.uri[0]}`
  }

  if (parentUrl.length === 1) {
    return `/${parentUrl[0]}`
  }

  return parentUrl.join('/')
})
</script>
